import React, { useMemo } from 'react';
import { IntlProvider as ReactIntProvider } from 'react-intl';

import en from 'languages/en-US.json';
import es from 'languages/es-US.json';
import fr from 'languages/fr-CA.json';

interface IProps {
  children: React.ReactNode;
}

const getMessages = (locale = 'en-US'): Record<string, string> => {
  if (locale.startsWith('es')) {
    return es;
  } else if (locale.startsWith('fr')) {
    return fr;
  } else {
    return en;
  }
};

export const IntlProvider = ({ children }: IProps) => {
  const lang = useMemo(() => window.navigator.language, []);
  const translations = useMemo(() => getMessages(lang), [lang]);

  return (
    <ReactIntProvider
      locale={lang}
      key={lang}
      messages={translations}
      defaultLocale='en-US'
    >
      {children}
    </ReactIntProvider>
  );
};

export default IntlProvider;
